import React from "react";

const Berserker = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Berserker</b>
      </div>
      <div className="helpDescription">
        <b>Information about the Berserker perk</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          The <b>Berserker</b> is focused on close-quarters combat, excelling at
          taking on enemies up close and dealing high melee damage. The
          Berserker perk emphasizes using melee weapons to inflict heavy damage
          and tank incoming attacks, making it a versatile role in the
          frontlines.
        </div>
        <div className="perkInfo">
          <b>Weapons</b>: The Berserker has access to a variety of powerful
          melee weapons. These weapons allow for devastating attacks up close
          and are especially effective for cutting through swarms of Zeds.
        </div>
        <div className="listText">
          <b>Benefits</b> acquired by leveling this perk:
          <ul>
            <li>Bonuses for Berserker weapons:</li>
            <ul>
              <li>Increase in damage;</li>
              <li>Increase in fire speed;</li>
              <li>Increase in movement speed;</li>
              <li>Increase in reload speed;</li>
              <li>Increase in amount ammunition magazines;</li>
              <li>Increase in pickup amount of ammunition;</li>
              <li>Discount on ammunition;</li>
              <li>Reduced weapon price;</li>
            </ul>
            <li>General bonuses:</li>
            <ul>
              <li>Increased ability to leech health;</li>
              <li>Increase in damage reduction;</li>
              <li>Increase in bloat vomit damage reduction;</li>
              <li>Increase in carry weight;</li>
              <li>Increase in recoil control;</li>
            </ul>
          </ul>
        </div>
        <b>Team Role</b>: Berserkers are excellent at drawing enemy attention
        and holding back the horde, protecting weaker teammates from being
        overwhelmed. Their ability to absorb damage and dish out massive melee
        hits makes them a cornerstone in team defense.
      </div>
    </div>
  );
};

export default Berserker;
